<div class="container">
  <sui-flag-tag
    class="type-tag"
    [color]="
      group.type === 'private'
        ? 'gray'
        : group.type === 'home'
        ? 'home'
        : 'point'
    "
    >{{
      group.type === 'private'
        ? '비공개'
        : group.type === 'home'
        ? '기본'
        : '공개'
    }}</sui-flag-tag
  >
  <div class="box">
    <div class="status-tags">
      <!-- <sui-rounded-tag *ngIf="group.status === 'invited'" color="point"
        >* 초대된 그룹입니다.</sui-rounded-tag
      >
      <sui-rounded-tag *ngIf="group.status === 'kicked'"
        >* 내보내기된 그룹입니다.</sui-rounded-tag
      > -->
      <sui-rounded-tag
        *ngIf="invitedGroupId === group.id"
        color="invitation"
        class="invitation-tag mobile"
        >* 초대받은 그룹책</sui-rounded-tag
      >
    </div>

    <div class="top">
      <div class="top-top">
        <div class="name" (mouseleave)="onNameHover(false)">
          <span
            *ngIf="group.type !== 'home'"
            class="name-text"
            #nameText
            (mouseenter)="onNameHover(true)"
            (touchstart)="onNameTouch($event)"
            [class.is-hovered]="isNameHovered"
            ><b>{{ group.name }}</b> 그룹책</span
          >
          <span
            *ngIf="group.type === 'home'"
            class="name-text"
            #nameText
            (mouseenter)="onNameHover(true)"
            (touchstart)="onNameTouch($event)"
            [class.is-hovered]="isNameHovered"
            ><b>모두</b> 그룹책({{ group.content.title }})</span
          >
          <sui-rounded-tag
            *ngIf="invitedGroupId === group.id"
            class="invitation-tag"
            color="invitation"
            >* 초대받은 그룹책</sui-rounded-tag
          >
          <div
            class="name-popover"
            *ngIf="isNameHovered"
            #namePopover
            (click)="$event.stopPropagation()"
          >
            <div class="popover-content">
              <div class="popover-content-header">
                <div class="popover-content-group-name">
                  <ng-container *ngIf="group.type !== 'home'">
                    <b>{{ group.name }}</b> 그룹책
                  </ng-container>
                  <ng-container *ngIf="group.type === 'home'">
                    <b>모두</b> 그룹책({{ group.content.title }})
                  </ng-container>
                </div>
                <div class="popover-content-group-button">
                  <button
                    sui-mini-button
                    (click)="_onCopyInvitationTextButtonClick($event)"
                  >
                    초대링크 복사하기
                    <sui-icon name="복사"></sui-icon>
                  </button>
                </div>
              </div>
              <div class="divider"></div>
              <div class="text">
                {{ group.description }}
              </div>
            </div>
          </div>
        </div>

        <div class="integrate-button">
          <div class="hidden-tag" *ngIf="group.is_hidden">숨김 그룹</div>

          <sui-icon
            *ngIf="!isLiked"
            name="즐겨찾기"
            (click)="onClickFavoriteButton(true)"
          ></sui-icon>
          <sui-icon
            *ngIf="isLiked"
            type="solid"
            name="즐겨찾기"
            (click)="onClickFavoriteButton(false)"
          ></sui-icon>
          <sui-icon
            (click)="onMoreClick()"
            name="더보기 세로형"
            #moreButton
          ></sui-icon>

          <ng-container *ngIf="isMoreMenuOpen">
            <sui-menu cdkMenu #moreMenu>
              <button
                sui-menu-item
                cdkMenuItem
                (click)="_onGroupDetailsButtonClick()"
              >
                그룹책 상세보기
              </button>
              <button
                *ngIf="
                  (group.status === 'joined' || group.status === 'owned') &&
                  group.type === 'private'
                "
                sui-menu-item
                cdkMenuItem
                (click)="_onExitGroupButtonClick()"
              >
                그룹책 그만보기
              </button>
            </sui-menu>
          </ng-container>
        </div>
      </div>
      <div class="top-bottom">
        <div class="info">
          <div class="private-group-info" *ngIf="group.type === 'private'">
            <span>만든이: {{ group.leader_nickname }}</span>
            <span>|</span>
            <span
              [class.is-warning]="group.member_count === group.max_member_count"
              >{{ group.member_count }}명 함께읽는 중</span
            >
          </div>
          <span *ngIf="group.type !== 'private'" class="member-count"
            >{{ group.member_count }}명 함께읽는 중</span
          >
        </div>
      </div>
    </div>
    <div class="bottom">
      <div class="sharing-status">
        <div class="item">
          <sui-icon name="밑줄"></sui-icon>밑줄 ({{ group.highlight_count }})
        </div>
        <div class="item">
          <sui-icon name="댓글"></sui-icon>댓글 ({{ group.memo_count }})
        </div>
      </div>
      <div class="actions">
        <ng-content></ng-content>
      </div>
    </div>
  </div>
</div>
